
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuItalianItalianImage } from "@src/constants/images";
import { meta as kevelosPageMeta } from "./kevelos.mdx";

export const meta = {
  path: "/media/harajuku/italian",
  title: "【大人向け】休日ランチにぴったりな原宿のイタリアン３選",
  description: "原宿で名店のイタリアンが食べられるお店を厳選してご紹介します。休日に雰囲気の良いところでおしゃれなランチが食べたいという大人な方に向けた記事になります。お店の特徴、雰囲気、人気のランチメニューなどをご紹介。その日の気分に合わせて気になったお店に足を運んでいただき、素敵なランチタイムをお過ごしください。",
  topImg: harajukuItalianItalianImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "まとめ記事", "デート", "イタリアン"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で名店のイタリアンが食べられるお店を厳選してご紹介します。`}</p>
    <p>{`休日に雰囲気の良いところでおしゃれなランチが食べたいという大人な方に向けた記事になります。`}</p>
    <p>{`原宿で屈指の実力を誇る名店、チーズなしのシンプルピザが人気のお店、原宿を見渡せる雰囲気抜群のイタリアンなど、個性際立つお店をご紹介させていただきます。`}</p>
    <p>{`お店の特徴、雰囲気、人気のランチメニューなどをみて、気になったお店に足を運んでいただき、素敵なランチタイムをお過ごしください。`}</p>
    <h2>{`エミリア`}</h2>
    <InstaImage postId="CA-fw0nD8JW" mdxType="InstaImage" />
    <p>{`原宿にはイタリアンが少ないと言われる中、本格的なイタリアンが食べられる指折りのお店として有名ななのがエミリア。`}</p>
    <p>{`食べログの評価は 3.7 を超える評価で、原宿の中では上位に入る実力派のお店。`}</p>
    <p>{`ディナーだと値段が高くて手が出しづらいという方が多いのですが、ランチだとお手頃な値段で食事ができるのが特徴的です。`}</p>
    <h3>{`雰囲気のある店内`}</h3>
    <p>{`木造の外観をしたお店は、イタリアの隠れた名店を思わせるような風格。
カウンター席、テラス席、テーブル席と席の種類が豊富にあります。特徴的なのは、赤色、グレー、白といった椅子の色が、それぞれ席の配置で異なっており、その色違いが店内の雰囲気を一層引き締めてくれているような雰囲気。`}</p>
    <p>{`ランチだと、天気の良い日にはテラス席で堪能するのもオススメです。`}</p>
    <h3>{`自家製のパスタ`}</h3>
    <InstaImage postId="BtQoNUGgzGb" mdxType="InstaImage" />
    <p>{`自家製で作るパスタ麺は、そのもちもちの食感と、小麦から広がる風味が楽しめることが人気の秘密になっています。
先ほどお伝えしたランチでは、パスタのランチがお手頃価格で楽しむことができます。
ディナーだと手が出しづらいからこそ、お好きなパスタをランチタイムの時間に堪能していただければと思います。`}</p>
    <ShopInfoBox shopId="brh20ka23akg00da7nv0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ケベロス`}</h2>
    <p>{`裏原位置するイタリアンピザの名店で、ランチの時間帯は行列ができることがほとんど。
食べログの評価は 3.7 を超え、毎年百名店にも選出されており、その人気は日に日に増え続けています。`}</p>
    <p>{`ハンバーガーの人気店グレートバーガー の隣で、テラス席を完備した赤色を基調としたお店なので、すぐに発見できると思います。`}</p>
    <h3>{`おしゃれな店内とテラス`}</h3>
    <InstaImage postId="B5sWStphbyT" mdxType="InstaImage" />
    <p>{`５０席のうち１３席がテラス席のケベロスでのランチは、晴れた日や、気候が穏やかなタイミングは、テラス席でのランチをすることをオススメします。
イタリアのランチのようにテラス席ピザを堪能する休日は素敵ですよね。`}</p>
    <InstaImage postId="BeazBVbHjP5" mdxType="InstaImage" />
    <p>{`また店内もおしゃれな絵画が飾ってあったり、やや薄暗く雰囲気のある店内だと、また違った楽しみを感じることができます。
その日の気分に合わせて店内かテラス席で素敵なランチタイムをお過ごしください。`}</p>
    <h3>{`人気のマリナーラとビール`}</h3>
    <InstaImage postId="CBpF6h7AmRQ" mdxType="InstaImage" />
    <p>{`1 番人気のランチメニューがマリナーラで、マリナーラはチーズを使わないトマトソースをベースとしたシンプルなピザ。
シンプルだからこそ、その味付けや焼き加減にお店の実力が問われます。`}</p>
    <p>{`そのマリナーラが 1 番人気で、本格的なイタリアの味を楽しむことができます。
昼にマリナーラをがっつきながら、ビールを飲んで過ごすランチタイムは最高のひと時。`}</p>
    <InstaImage postId="BcXk2bDlHF3" mdxType="InstaImage" />
    <p>{`他にもたくさんのイタリアンピザのメニューがあるのでランチの際はチェックしてみてください！`}</p>
    <LinkWithThumbnail meta={kevelosPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brh20vi23akg00da7o1g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ピッツエリア カンテラ`}</h2>
    <InstaImage postId="B_59g3-gDyM" mdxType="InstaImage" />
    <p>{`原宿のキュープラザ原宿の９階にあるイタリアンで、食べログの評価は 3.7 に迫る勢い。
食べログ百名店にも毎年選出されているお店で、実力も兼ね備えている名店です。`}</p>
    <p>{`雰囲気が抜群なのはもちろんのこと、産地の食材で作るイタリアンランチピザやパスタが美味しいと話題のカンテラ についてご紹介します。`}</p>
    <h3>{`デートにぴったりの店内`}</h3>
    <InstaImage postId="CBfR6zmAzIE" mdxType="InstaImage" />
    <p>{`雰囲気抜群なお店として知られていますが、そのデザインは洗練された印象がありつつも、木造の温かみも感じることができる店内。`}</p>
    <InstaImage postId="CBjehnTl8LX" mdxType="InstaImage" />
    <p>{`テラス席は、原宿エリアを一望できる抜群のロケーションで、晴れた日にはランチだけでなく景色も楽しめるようなお店は、デートにぴったり！`}</p>
    <h3>{`素材にこだわったメニュー`}</h3>
    <p>{`幅広いイタリアンメニューを提供しているのですが、どれも産地や食材にこだわって作られたメニューばかりです。
特に 1 番人気メニューのピザは、有名な産地で作られたブランドの全粒粉を使用していたり、パスタも有名な産地の食材をふんだんに使用して作られています。`}</p>
    <InstaImage postId="CBcufqmFbFN" mdxType="InstaImage" />
    <InstaImage postId="B9Dm5BDB8qd" mdxType="InstaImage" />
    <p>{`そんな素材の味にこだわったランチが堪能できるのもカンテラ の魅力です。
名店のイタリアンの味だけでなく、景色や雰囲気もしっかりと楽しみたい方には、カンテラがオススメです。`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿で人気のイタリアンの名店についてご紹介してきましたが、いかがでしたか。
イタリアンのお店が少なくイメージがない方も多いとは思いますが、食べログの百名店に選出されるお店もあり、隠れた名店が多いのが特徴。
気になるイタリアンのお店をピックアップし、ぜひ素敵なランチタイムをお過ごしください。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;